<template>
  <v-list>
    <v-list-tile v-for='(item, index) in items' :key='index'>
      <v-list-tile-title>
        <router-link :to='{ path: item.link, query: { referrer: item.referrer } }'>
          {{ item.title }}
        </router-link>
      </v-list-tile-title>
    </v-list-tile>
    <v-list-tile>
    <v-list-tile-title>
      <a :href='hgSupportUrl' target='_blank'>
        Homegauge Support
        <v-icon>open_in_new</v-icon>
      </a>
    </v-list-tile-title>
    </v-list-tile>
    <v-list-tile>
      <v-list-tile-title>
        <a :href='privacyCenterUrl' target='_blank'>
          Privacy Center
          <v-icon>open_in_new</v-icon>
        </a>
      </v-list-tile-title>

    </v-list-tile>

    <button class='logout-btn' type='button' @click='logout'>Logout</button>
  </v-list>
</template>

<script>
export default {
  data() {
    return {
      privacyCenterUrl: `${process.env.VUE_APP_HG_CLASSIC}privacy-center`,
      hgSupportUrl: `${process.env.VUE_APP_HG_CLASSIC}one/contact`,
    };
  },
  computed: {
    items() {
      return [
        { title: 'My Inspections', link: '/inspections' },
        { title: 'My Inspectors', link: '/inspectors' },
        { title: 'My Account', link: '/account' },
        { title: 'My Offers', link: '/offers', referrer: 'main_menu' },
      ];
    },
  },
  methods: {
    logout() {
      this.$store.dispatch('User/logout');
    },
  },
};
</script>

<style lang='scss' scoped>
@import '../../../styles/vars/theme';
@import '../../../styles/vars/typography';

.v-list {
  border-top: solid 4px $typography-color-link;
  padding-bottom: 20px;
  padding-top: 17px;

  a {
    color: $typography-color-link;
    font-size: 1.286rem;
    font-weight: $typography-weight-semibold;
    letter-spacing: 0.026rem;
    padding-left: 10px;
    padding-right: 10px;

    i {
      color: #a1a0a0;
      font-size: 1.35rem;
      vertical-align: middle;
    }
  }
}

.logout-btn {
  color: $typography-color-link;
  font-size: 1.286rem;
  font-weight: $typography-weight-bold;
  margin: 0;
  padding-bottom: 5px;
  padding-left: 25px;
  padding-top: 5px;
  text-align: left;
  width: 100%;

  &:active,
  &:hover {
    background-color: rgba(0, 0, 0, 0.15);
    outline: 0;
  }
}

@media only screen and (max-width: 960px) {
  .v-list {
    border-top: none;
  }
}
</style>

<style lang='scss'>
.v-list__tile:hover {
  background-color: rgba(0, 0, 0, 0.15) !important;
}
</style>
